export const ART_TYPE_LIST = [
	"Декоративно-прикладное искусство",
	"Театрально-декорационное искусство",
	"Архитектурные проекты",
	"Архитектура",
	"Скульптура",
	"Графика",
	"Живопись",
]